<template>
  <div>
    <english-push v-if="type == 'en'"></english-push>
    <chinese-push v-else></chinese-push>
  </div>
</template>

<script>
import ChinesePush from "./component/chinesePush.vue";
import EnglishPush from "./component/englishPush.vue";
export default {
  name: 'MailPush',
  components: {
    ChinesePush,
    EnglishPush
  },
  data() {
    return {
      type: "cn",
    }
  },
  created () {
    if (this.$route.params.language && this.$route.params.language == "english") {
      this.type = "en";
    } else {
      this.type = "cn";
    }
  }
}
</script>
